<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body">
      <br />
      <h2 class="subtitle">{{ $t("appSuggestion.text1") }}</h2>
      <br />
      <h2>{{ $t("appSuggestion.text2") }}</h2>
      <br /><br />
      <div class="columns">
        <div class="column marketLogo">
          <a
            href="https://play.google.com/store/apps/details?id=com.droiders.android.rointeconnect"
          >
            <img style="width: 8rem" src="/home/images/app/android.png" />
          </a>
        </div>
        <div class="column marketLogo">
          <a href="https://itunes.apple.com/es/app/rointe-connect/id1042610193">
            <img style="width: 8rem" src="/home/images/app/ios.png" />
          </a>
        </div>
      </div>
      <button
        class="button is-primary"
        type="button"
        @click="$emit('closeAppSuggestion')"
      >
        {{ $t("appSuggestion.button") }}
      </button>
      <br /><br />
    </section>
  </div>
</template>

<script>
export default {
  name: "app-suggestion-modal",
};
</script>

<style lang="scss" scoped>
.marketLogo {
  margin-top: -3rem;
}
</style>
